export default "__VITE_PUBLIC_ASSET__de2f1979__"